'use client'

import React from 'react'
import { Box, Flex, Stack, Text } from '@mantine/core'
import type { SkuComponentConfigMap } from '@/types/enums/sku-component-types'

type SkuVideoDataItem = SkuComponentConfigMap['skuVideoData']['items'][number]

export function NumberedSteps({ items }: { items: SkuVideoDataItem[] }) {
    return (
        <Stack gap={0} maw={640} mt={32}>
            {items.map((item, index) => (
                <Flex
                    key={`step-item-${index}`}
                    align="flex-start"
                    gap={{ base: 16, sm: 24 }}
                    pt={{ base: 16, sm: 20 }}
                    pb={{ base: 16, sm: 20 }}
                    style={{ borderTop: '1px solid rgba(31, 30, 29, 0.12)' }}
                >
                    <Text
                        c="gray.9"
                        fz={34}
                        fw={450}
                        lh="100%"
                        lts={-0.34}
                        style={{ flexShrink: 0, minWidth: 24 }}
                    >
                        {index + 1}
                    </Text>
                    <Box miw={0}>
                        <Text c="gray.9" fz={24} fw={450} lh="100%" lts={-0.24} mb={8}>
                            {item.title}
                        </Text>
                        {item.description ? (
                            <Text c="gray.7" fz={16} fw={450} lh="150%" component="p" m={0}>
                                {item.description}
                            </Text>
                        ) : null}
                    </Box>
                </Flex>
            ))}
        </Stack>
    )
}
